import { MuiInput } from "./../components/basicComponent/MuiInput";
import Header from "./../sharedScreens/Header";
import SideMenu from "./../sharedScreens/menuItems/SideMenu";
import React, { useState } from "react";
import MuiButton from "./../components/basicComponent/MuiButton";
import MuiSearchSelect from "./../components/basicComponent/MuiSearchSelect";

const InsurancePlan = () => {
  const [active, setActive] = useState<Boolean>(false);
  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header mb-1 managebookingg">
              <h3 className="card-title ">Insurance Plan View</h3>
              <div>
                <button
                  className="fliter-btn"
                  onClick={() => {
                    setActive(!active);
                  }}
                >
                  <span> {active ? "View " : "Create"}</span>
                </button>
              </div>
            </div>
            <div className="card">
              <div className="card-body flex flex-col justify-end items-stretch grow  py-1 mt-5">
                {active && (
                  <div className="row">
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                      <MuiSearchSelect
                        placeholder={"Supplier"}
                        label="Supplier"
                        options={[]}
                        onChange={function (
                          value: string,
                          id: string,
                          data: any
                        ): void {
                          throw new Error("Function not implemented.");
                        }}
                        value={""}
                      />
                    </div>

                    <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                      <MuiSearchSelect
                        placeholder={"Plan"}
                        label="Plan"
                        options={[]}
                        onChange={function (
                          value: string,
                          id: string,
                          data: any
                        ): void {
                          throw new Error("Function not implemented.");
                        }}
                        value={""}
                      />
                    </div>

                    <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                      <MuiSearchSelect
                        placeholder={"Traveller Type"}
                        label="Traveller Type"
                        options={[]}
                        onChange={function (
                          value: string,
                          id: string,
                          data: any
                        ): void {
                          throw new Error("Function not implemented.");
                        }}
                        value={""}
                      />
                    </div>

                    <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                      <MuiInput
                        placeholder="Enter Plan Name"
                        label={"Plan Name"}
                      />
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                      <MuiInput
                        placeholder="Plan Name Code"
                        label={"Plan Name Code"}
                      />
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                      <MuiInput placeholder="Plan Type" label={"Plan Type"} />
                    </div>

                    <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                      <MuiInput
                        placeholder="Plan Type Code"
                        label={"Plan Type Code"}
                      />
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                      <MuiSearchSelect
                        placeholder={"Geographical Area"}
                        options={[]}
                        onChange={function (
                          value: string,
                          id: string,
                          data: any
                        ): void {
                          throw new Error("Function not implemented.");
                        }}
                        value={""}
                      />
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                      <MuiInput
                        placeholder="Geographical Code"
                        label={"Geographical Code"}
                      />
                    </div>

                    <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                      <MuiInput
                        placeholder="Minimum Age "
                        label={"Minimum Age "}
                      />
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                      <MuiInput
                        placeholder="Maximum Age"
                        label={"Maximum Age"}
                      />
                    </div>

                    <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                      <MuiInput
                        placeholder="Minimum Days "
                        label={"Minimum Days "}
                      />
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                      <MuiInput
                        placeholder="Maximum Days "
                        label={"Maximum Days "}
                      />
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                      <MuiSearchSelect
                        placeholder={"Status"}
                        options={[]}
                        onChange={function (
                          value: string,
                          id: string,
                          data: any
                        ): void {
                          throw new Error("Function not implemented.");
                        }}
                        value={""}
                      />
                    </div>

                    <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                      <MuiInput
                        placeholder="Sum insured"
                        label={"Sum insured"}
                      />
                    </div>

                    <div className="col-md-4">
                      <MuiInput
                        placeholder="Sum insured Code"
                        label={"Sum insured Code"}
                      />
                    </div>
                    <div className="col-md-4">
                      <MuiSearchSelect
                        placeholder={"Pre Existing Disease"}
                        options={[]}
                        onChange={function (
                          value: string,
                          id: string,
                          data: any
                        ): void {
                          throw new Error("Function not implemented.");
                        }}
                        value={""}
                      />
                    </div>

                    <div className="pb-2 user-button w-full text-end onboard-btn">
                      <MuiButton
                        className="main-clear-btn"
                        label="Clear"
                        type="submit"
                      />
                      <MuiButton
                        label="Create"
                        type="submit"
                        variant="outlined"
                        fullWidth={false}
                        className="main-btn"
                      />
                    </div>
                  </div>
                )}

                {!active && (
                  <div className="row">
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                      <MuiSearchSelect
                        placeholder={"Supplier"}
                        label="Supplier"
                        options={[]}
                        onChange={function (
                          value: string,
                          id: string,
                          data: any
                        ): void {
                          throw new Error("Function not implemented.");
                        }}
                        value={""}
                      />
                    </div>

                    <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                      <MuiSearchSelect
                        placeholder={"Status"}
                        label="Status"
                        options={[]}
                        onChange={function (
                          value: string,
                          id: string,
                          data: any
                        ): void {
                          throw new Error("Function not implemented.");
                        }}
                        value={""}
                      />
                    </div>

                    <div className="pb-2 user-button w-full text-end onboard-btn">
                      <MuiButton
                        className="main-clear-btn"
                        label="Clear"
                        type="submit"
                      />
                      <MuiButton
                        label="Create"
                        type="submit"
                        variant="outlined"
                        fullWidth={false}
                        className="main-btn"
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default InsurancePlan;
